import { render } from "./mailings.html?vue&type=template&id=5845178b&scoped=true&ts=true&external"
import script from "./Mailings.vue?vue&type=script&lang=ts"
export * from "./Mailings.vue?vue&type=script&lang=ts"

import "./Mailings.vue?vue&type=style&index=0&id=5845178b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5845178b"]])

export default __exports__